// extracted by mini-css-extract-plugin
export var ProContainer = "coursepage-module--ProContainer--37JQO";
export var StarRating = "coursepage-module--StarRating--PcN4l";
export var accessSection = "coursepage-module--accessSection--x5SRH";
export var accordianContent = "coursepage-module--accordianContent--oGPeU";
export var addIcon = "coursepage-module--addIcon--Jn77W";
export var addIconMinus = "coursepage-module--addIconMinus--+5zcl";
export var adobeApMb = "coursepage-module--adobeApMb--tPfPj";
export var arrow = "coursepage-module--arrow--zXlGJ";
export var banner = "coursepage-module--banner--axwQo";
export var bannerPinkBtn = "coursepage-module--bannerPinkBtn--mDy+7";
export var box = "coursepage-module--box--84pwo";
export var cardBox = "coursepage-module--cardBox--Z0xN5";
export var carousalButtongroup = "coursepage-module--carousalButtongroup--jbxM3";
export var catalogueMenu = "coursepage-module--catalogueMenu--gzASm";
export var certifiedImgSection = "coursepage-module--certifiedImgSection--N7s3g";
export var certifiedSection = "coursepage-module--certifiedSection--JgrFd";
export var check = "coursepage-module--check--3Mext";
export var checkInfox = "coursepage-module--checkInfox--erBjM";
export var closeBtn = "coursepage-module--closeBtn--+zhqJ";
export var corporateSection = "coursepage-module--corporateSection--O9kt2";
export var courseHeader = "coursepage-module--courseHeader--KjMhM";
export var courseIcon = "coursepage-module--courseIcon--RV-9V";
export var coursePage = "coursepage-module--coursePage--0hdOZ";
export var desktop = "coursepage-module--desktop--TOUb2";
export var disable = "coursepage-module--disable--q06n5";
export var freeCta = "coursepage-module--freeCta--92Ddk";
export var headerBottomSection = "coursepage-module--headerBottomSection--YOqJ2";
export var headerContainer = "coursepage-module--headerContainer--8Eowe";
export var headerIcon = "coursepage-module--headerIcon--X3dak";
export var headerImg = "coursepage-module--headerImg--5s0Xj";
export var headerNavigationLinks = "coursepage-module--headerNavigationLinks--1CieB";
export var headerRoutingLinks = "coursepage-module--headerRoutingLinks--tKpfq";
export var headerRule = "coursepage-module--headerRule--TD-z7";
export var headerTimerSection = "coursepage-module--headerTimerSection--FJ0uW";
export var headerTitle = "coursepage-module--headerTitle--KkUs6";
export var hiddenDiv = "coursepage-module--hiddenDiv--ytTTF";
export var hide = "coursepage-module--hide--BSUxz";
export var hideOnMobile = "coursepage-module--hideOnMobile--8vHQL";
export var highlight = "coursepage-module--highlight--04wJb";
export var hr = "coursepage-module--hr--zpYa7";
export var learnContent = "coursepage-module--learnContent--cjfto";
export var learnDetails = "coursepage-module--learnDetails--hJB8t";
export var learnSection = "coursepage-module--learnSection--lKp3f";
export var leftContentSection = "coursepage-module--leftContentSection--Zo30l";
export var level1 = "coursepage-module--level1--1wWI5";
export var level2 = "coursepage-module--level2--2sYxg";
export var level3 = "coursepage-module--level3---4XmC";
export var levels = "coursepage-module--levels--azaDn";
export var levelsWhat = "coursepage-module--levelsWhat--D58-h";
export var mediaBtn = "coursepage-module--mediaBtn--Da5ul";
export var moduleContent = "coursepage-module--moduleContent--2yofe";
export var moduleContentWrapper = "coursepage-module--moduleContentWrapper--9iv1o";
export var moduleData = "coursepage-module--moduleData--qyDP7";
export var moduleHideLessonCta = "coursepage-module--moduleHideLessonCta--22085";
export var moduleTitle = "coursepage-module--moduleTitle--DhsK3";
export var newProductContent = "coursepage-module--newProductContent--zCrBS";
export var oldProductContent = "coursepage-module--oldProductContent--ARnmC";
export var pinklargeCta = "coursepage-module--pinklargeCta--SCJo6";
export var planDetails = "coursepage-module--planDetails--znXu1";
export var popCardContent = "coursepage-module--popCardContent--wklue";
export var popCourseName = "coursepage-module--popCourseName--NWRMQ";
export var popEnrollCount = "coursepage-module--popEnrollCount--AiFIR";
export var popEnrollCta = "coursepage-module--popEnrollCta--DZKu-";
export var popEnrollSection = "coursepage-module--popEnrollSection--YPdW7";
export var popMoreCta = "coursepage-module--popMoreCta--aCMbH";
export var popRating = "coursepage-module--popRating--7PmzW";
export var popularCardImg = "coursepage-module--popularCardImg--6yCJU";
export var prev = "coursepage-module--prev--DmQPp";
export var productCarousal = "coursepage-module--productCarousal--jsJLS";
export var productCourseData = "coursepage-module--productCourseData--qeX7P";
export var productCourseHeader = "coursepage-module--productCourseHeader--GlukA";
export var productCourses = "coursepage-module--productCourses--5ceVy";
export var productDetails = "coursepage-module--productDetails--4nj7E";
export var productDetailsSection = "coursepage-module--productDetailsSection--9dHmX";
export var productHeaderExtension = "coursepage-module--productHeaderExtension--g7HFa";
export var recognisedCertificate = "coursepage-module--recognisedCertificate--ecCme";
export var recognisedIaoIcon = "coursepage-module--recognisedIaoIcon--oaxl6";
export var rightPartnerDetails = "coursepage-module--rightPartnerDetails--QKNBM";
export var rightPartnerSection = "coursepage-module--rightPartnerSection--9uYcm";
export var section = "coursepage-module--section--Vh38e";
export var shareBtn = "coursepage-module--shareBtn--zEJ6D";
export var shareBtnMobile = "coursepage-module--shareBtnMobile--mhzXx";
export var shareMedia = "coursepage-module--shareMedia--oYIzi";
export var shawBtn = "coursepage-module--shawBtn--No3iX";
export var show = "coursepage-module--show--0CnQR";
export var showOnMobile = "coursepage-module--showOnMobile--2zeTy";
export var stickyButton = "coursepage-module--stickyButton--cHipF";
export var stickyInfo = "coursepage-module--stickyInfo--EDW8R";
export var subscribeSection = "coursepage-module--subscribeSection--DOPba";
export var textWrapper = "coursepage-module--textWrapper--kclFJ";
export var timerText = "coursepage-module--timerText--hhnBl";
export var timerWrapper = "coursepage-module--timerWrapper--+4V5l";
export var trailDay = "coursepage-module--trailDay--uzNLk";
export var websiteHeaderExtension = "coursepage-module--websiteHeaderExtension--GdZQ5";
export var what = "coursepage-module--what--UtQ01";
export var word = "coursepage-module--word--9eFVS";